<template>
  <div class="container">
    <el-form
      ref="modifyData"
      :model="modifyData"
      inline
      size="mini"
      class="table-search-part modify-btn-part"
    >
      <div>
        <el-form-item label="User ID">
          <el-input v-model="modifyData.userId" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="User Limit">
          <el-select
            v-model="modifyData.levelId"
            placeholder="User Limit"
            @change="getLevel(modifyData.levelId)"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in riskLevelList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Level">
          <el-select
            v-model="modifyData.userLevelId"
            clearable
            filterable
            placeholder="Level"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in levelList"
              :key="item.id"
              :label="item.name"
              :value="String(item.id)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Label">
          <el-select
            v-model="modifyData.labelIds"
            multiple
            :multiple-limit="5"
            collapse-tags
            placeholder="Label"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in lableList"
              :key="item.id"
              :label="item.labelName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Odds Level">
          <el-select
            v-model="modifyData.oddsLevel"
            clearable
            filterable
            placeholder="Odds Level"
            :popper-append-to-body="false"
          >
            <el-option v-for="item in oddList" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Alert">
          <el-switch
            v-model="modifyData.isAlert"
            :active-value="true"
            :inactive-value="false"
            :width="35"
            active-color="#00A791"
            inactive-color="#D5D9E0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="Status">
          <el-switch
            v-model="modifyData.status"
            :active-value="1"
            :inactive-value="0"
            :width="35"
            active-color="#00A791"
            inactive-color="#D5D9E0"
          ></el-switch>
        </el-form-item>
      </div>
      <!-- <div>
        <sportTable :list="list" :loading="loading" :iskey="'riskLevelDetailDTOList'" />
      </div>-->

      <div class="remark-wrapper">
        <div class="remark-head">Remark</div>
        <div class="remark-contain">
          <el-input
            type="textarea"
            maxlength="240"
            show-word-limit
            :rows="5"
            placeholder="请输入内容"
            v-model="modifyData.remark"
          ></el-input>
        </div>
      </div>

      <div class="table-search-part btn-wrapper">
        <el-button class="search-btn" @click="handleSave()">Save</el-button>
        <el-button class="clear-btn" @click="handleCancel">Cancel</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
//import sportTable from "@/components/sportTable/index";

import {
  getMemberDetails,
  getMemberUpdate,
  getRiskLevel,
  getLableList,
  getLevelList
} from "@/api/member";
import { getRiskDetailsList } from "@/api/risk";

export default {
  name: "MemberModify",
  data() {
    return {
      list: [],
      loading: false,
      queryData: {
        riskLevelId: "",
        userId: 0
      },
      riskLevelList: [],
      lableList: [],
      levelList: [],
      oddList: [
        { id: 0, label: "Channel Config" },
        { id: 1, label: "A" },
        { id: 2, label: "B" },
        { id: 3, label: "C" },
        { id: 4, label: "D" },
        { id: 5, label: "E" },
        { id: 6, label: "F" },
        { id: 7, label: "G" }
      ],
      modifyData: {
        userId: "",
        levelId: "",
        riskLevelSubReqList: [],
        remark: "",
        isAlert: "",
        status: "",
        labelIds: [],
        userLevelId: "",
        oddsLevel: ""
      },
      dialogVisible: false,
      index: 0
    };
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await getRiskDetailsList(this.queryData);
        const data = res.data || {};
        this.list = [data] || [];
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getDetail() {
      this.queryData.userId = this.$route.query.userId;
      this.loading = true;
      try {
        const res = await getMemberDetails(this.queryData);
        const data = res.data || {};
        this.modifyData.userId = data.userId;
        data.levelId != -1 ? (this.modifyData.levelId = data.levelId) : "";
        this.modifyData.lastLoginTimeText = data.lastLoginTimeText;
        this.modifyData.remark = data.remark;
        this.modifyData.status = data.status;
        this.modifyData.isAlert = data.isAlert;
        if (data.oddsLevelSource == 3) {
          this.modifyData.oddsLevel = 0;
        } else if (data.oddsLevelSource == 1) {
          this.modifyData.oddsLevel = data.oddsLevel;
        } else {
          this.modifyData.oddsLevel = 0;
        }
        if (data.userLevelId == 0) {
          this.modifyData.userLevelId = "";
        } else {
          this.modifyData.userLevelId = data.userLevelId;
        }
        this.modifyData.labelIds = Object.values(data.labelList).map(
          el => el.id
        );
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    // utc时间
    formatUtc(time) {
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    // 删除
    handleDelete(index) {
      this.$refs["dialogDom"].isShowDia(this.title, true);
      this.index = index;
    },
    Delete() {
      this.list.splice(this.index, 1);
      this.Close();
    },

    // 保存
    async handleSave() {
      if (!this.modifyData.userLevelId) {
        this.modifyData.userLevelId = 0;
      }
      const res = await getMemberUpdate(this.modifyData);
      if (res.code == 0) {
        this.$message({ message: "update success", type: "success" });
        this.getDetail();
        this.$router.push({
          path: "/member/detail",
          query: {
            userId: this.queryData.userId,
            levelId: this.modifyData.levelId,
            activeName: 3
          }
        });
      } else {
        this.$message({ message: res.message, type: "warning" });
      }
    },
    async getRiskLevel() {
      const res = await getRiskLevel();
      let data = res.data || {};
      this.riskLevelList = this.getArray(data);
    },
    getArray(data) {
      return Object.keys(data).map(el => {
        return {
          id: el,
          name: data[el]
        };
      });
    },
    getLevel(e) {
      this.modifyData.levelId = e;
      this.queryData.riskLevelId = e;
    },
    async getLableList() {
      const res = await getLableList();
      let data = res.data || {};
      this.lableList = data;
    },
    async getLevelList() {
      const res = await getLevelList({});
      let data = res.data || [];
      this.levelList = data;
    },
    // 取消
    handleCancel() {
      this.$router.push({
        path: "/member/detail",
        query: {
          userId: this.queryData.userId,
          levelId: this.queryData.riskLevelId,
          activeName: 3
        }
      });
    }
  },
  components: {
    //sportTable
  },
  mounted() {
    this.queryData.riskLevelId = this.$route.query.levelId;
    this.getList();
    this.getDetail();
    this.getRiskLevel();
    this.getLableList();
    this.getLevelList();
  }
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
  margin: 10px 0 0 0;
}
/deep/.risk-table {
  .el-table th {
    padding: 6px 0;
  }
}
.remark-wrapper {
  margin: 0 !important;
}
</style>
